module.exports = __webpack_public_path__ + "static/media/projects.0ad837fc.svg";